import { SET_REDIRECT } from '../actions/helpers/redirect';
import { DO_LOGOUT, SET_LOGGED_IN, SET_POPOVER } from '../actions/login';

const initialState = {
  isLoggedIn: false,
  showPopover: false,
  notificationCount: 0,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case DO_LOGOUT:
      return Object.assign({}, state, {
        isLoggedIn: false,
      });
    case SET_LOGGED_IN:
      return Object.assign({}, state, {
        isLoggedIn: true,
      });
    case SET_POPOVER:
      return Object.assign({}, state, { showPopover: !!action.value });
    case SET_REDIRECT:
      return Object.assign({}, state, {
        redirect: action.value,
      });
    default:
      return state;
  }
};

export default loginReducer;
